import React, { useEffect, useState } from 'react'
import './ProductoDetalleBtnCompra.scss'
import { DocumentIcon, NotAvailableIcon } from '../utils/icons'
import { connect } from 'react-redux'
import { setBudget, setBudgetImplantacion } from '../actions/index'
import { showPopup } from '../actions/index'
import * as _ from 'lodash'

const ProductoDetalleBtnCompra = (props) => {
    const product = props.product
    const accion = props.accion
    const productType = props.productType
    const quantity = props.quantitySelected
    const format = props.formatSelected
    const total = props.totalSelected
    const [productInBudget, setproductInBudget] = useState([])
    const [isAddedTemp, setIsAddedTemp] = useState(false)

    useEffect(() => {
        setproductInBudget([])
        setproductInBudget(_.filter(props.budget, productBudget => {
            return productBudget.product.RefSuelto === product.RefSuelto && productBudget.format === props.formatSelected
        }))
    }, [props.formatSelected, props.budget, props.product])

    const handleClickCompra = () => {
      if(accion == 'añadir'){
        props.handleCloseProductComplement()
      }else if(productType == 'implantacion'){
        props.preSetBudgetImplantacion()
        setIsAddedTemp(true)
      }else{
        const productValues = {
            product: product,
            quantity: quantity,
            format: format,
            total: total,
        }
        props.showPopup({ active: true, message: 'Producto añadido', type: 'success' })
        props.setBudget(productValues)
      }
    }

    return (
        <React.Fragment>
            {product.Estado !== '' && product.Estado !== 'PROXIMAMENTE' &&
                <React.Fragment>
                    {(productInBudget.length > 0 || isAddedTemp) ?
                        <div className="producto-detalle-btn-compra" onClick={handleClickCompra} title="Producto ya añadido al presupuesto">
                            <div className="btn anadido">
                                <div className="icono"><DocumentIcon size={20} /></div>
                                <div className="texto"><p>AÑADIDO</p></div>
                            </div>
                        </div>
                        :
                        // (accion != 'añadir' ?
                            <div className="producto-detalle-btn-compra" onClick={handleClickCompra} title="Botón para añadir el producto con la configuración elegida al nuevo presupuesto">
                                <div className="btn">
                                    <div className="icono"><DocumentIcon size={20} /></div>
                                    <div className="texto"><p>AÑADIR A PRESUPUESTO</p></div>
                                </div>
                            </div>
                        //     :
                        //     <div className="producto-detalle-btn-compra" onClick={handleClickCompra} title="Botón para añadir el producto con la configuración elegida">
                        //         <div className="btn">
                        //             <div className="icono"><DocumentIcon size={20} /></div>
                        //             <div className="texto"><p>AÑADIR A LA LISTA</p></div>
                        //         </div>
                        //     </div>
                        // )
                    }
                </React.Fragment>
            }
            {product.Estado === '' &&
                <div className="producto-detalle-btn-compra" title="Producto no disponible temporalmente">
                    <div className="btn not-available">
                        <div className="icono"><NotAvailableIcon /></div>
                        <div className="texto"><p>NO DISPONIBLE</p> <p>TEMPORALMENTE</p></div>
                    </div>
                </div>

            }
            {product.Estado === 'PROXIMAMENTE' &&
                <div className="producto-detalle-btn-compra" title="Producto no disponible temporalmente">
                    <div className="btn not-available">
                        <div className="texto"><p>PRÓXIMAMENTE</p></div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

const mapDispatchToProps = {
    setBudget,
    setBudgetImplantacion,
    showPopup
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleBtnCompra)